const LEAD_FORM_SELECTOR = '[data-lead-capture-form]';
const STATUS_SELECTOR = '[data-lead-status]';
const RECAPTCHA_SELECTOR = '.g-recaptcha';
const RECAPTCHA_RESPONSE_SELECTOR = 'textarea[name="g-recaptcha-response"], input[name="g-recaptcha-response"]';
const DEFAULT_ERROR_MESSAGE = 'We could not send your request right now. Please try again.';
const RECAPTCHA_REQUIRED_MESSAGE = 'Please complete the reCAPTCHA before submitting.';
const SUCCESS_MESSAGE = 'Thank you. Your information has been submitted.';
const DEFAULT_HOW_DID_YOU_HEAR = 'Not specified';
const DEFAULT_SOURCE_WEBSITE = 'drbrownslab.com';
const ALLOWED_SOURCE_WEBSITES = new Set([
  'tricoexam.com',
  'drbrownsgroup.com',
  'drbrownslab.com',
  'usa.drbrownslab.com',
  'sa.drbrownslab.com',
  'bm.drbrownslab.com',
]);
const COUNTRY_CODES = [
  'AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ', 'BS', 'BH',
  'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BQ', 'BA', 'BW', 'BV', 'BR', 'IO', 'BN', 'BG', 'BF',
  'BI', 'CV', 'KH', 'CM', 'CA', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR',
  'CI', 'HR', 'CU', 'CW', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET',
  'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR', 'GL', 'GD', 'GP',
  'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HM', 'VA', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE',
  'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KP', 'KR', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS',
  'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX',
  'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP', 'NL', 'NC', 'NZ', 'NI', 'NE', 'NG',
  'NU', 'NF', 'MK', 'MP', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'PR',
  'QA', 'RE', 'RO', 'RU', 'RW', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS',
  'SC', 'SL', 'SG', 'SX', 'SK', 'SI', 'SB', 'SO', 'ZA', 'GS', 'SS', 'ES', 'LK', 'SD', 'SR', 'SJ', 'SE', 'CH',
  'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'AE',
  'GB', 'US', 'UM', 'UY', 'UZ', 'VU', 'VE', 'VN', 'VG', 'VI', 'WF', 'EH', 'YE', 'ZM', 'ZW', 'XK',
];

if (!window.__leadCaptureFormInitialized) {
  window.__leadCaptureFormInitialized = true;

  initializeCountrySelects();
  document.addEventListener('shopify:section:load', initializeCountrySelects);

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const formRoot = form.closest(LEAD_FORM_SELECTOR);

      if (!(formRoot instanceof HTMLElement)) return;

      event.preventDefault();
      event.stopPropagation();

      if (!form.reportValidity()) return;

      const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
      const originalSubmitText = submitButton instanceof HTMLButtonElement ? submitButton.textContent : null;

      setStatus(form);
      setSubmitting(submitButton, true);

      if (submitButton instanceof HTMLButtonElement) {
        submitButton.textContent = 'Submitting...';
      }

      try {
        const endpoint = getEndpoint(formRoot);

        if (!endpoint) {
          throw new Error('Missing lead endpoint');
        }

        const captchaToken = getCaptchaToken(form);

        if (hasRecaptcha(form) && !captchaToken) {
          throw new Error(RECAPTCHA_REQUIRED_MESSAGE);
        }

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(buildPayload(form, captchaToken, getSubmissionId(formRoot))),
        });

        const responseData = await parseJsonResponse(response);

        if (!response.ok) {
          throw new Error(getErrorMessage(response, responseData));
        }

        form.reset();
        delete formRoot.dataset.submissionId;
        resetRecaptcha(form);
        setStatus(form, 'success', getSuccessMessage(responseData));
        form.dispatchEvent(
          new CustomEvent('lead:success', {
            bubbles: true,
            detail: { responseData },
          })
        );
        scheduleSuccessRedirect(formRoot);
      } catch (error) {
        console.error(error);
        setStatus(form, 'error', getNetworkErrorMessage(error));
      } finally {
        setSubmitting(submitButton, false);

        if (submitButton instanceof HTMLButtonElement && originalSubmitText !== null) {
          submitButton.textContent = originalSubmitText;
        }
      }
    },
    true
  );
}

/**
 * @param {HTMLElement} formRoot
 * @returns {string}
 */
function getEndpoint(formRoot) {
  const defaultEndpoint = formRoot.dataset.leadEndpoint || '';
  const marketCountryCode = getMarketCountryCode(formRoot);

  if (marketCountryCode === 'US') {
    return formRoot.dataset.leadEndpointUs || defaultEndpoint;
  }

  if (marketCountryCode === 'ZA') {
    return formRoot.dataset.leadEndpointSouthAfrica || defaultEndpoint;
  }

  return defaultEndpoint;
}

/**
 * @param {HTMLElement} formRoot
 * @returns {string}
 */
function getMarketCountryCode(formRoot) {
  const hostname = window.location.hostname.toLowerCase().replace(/^www\./, '');

  if (hostname === 'usa.drbrownslab.com') {
    return 'US';
  }

  if (hostname === 'sa.drbrownslab.com') {
    return 'ZA';
  }

  return normalizeMarketCountryCode(formRoot.dataset.leadMarketCountry);
}

/**
 * @param {unknown} value
 * @returns {string}
 */
function normalizeMarketCountryCode(value) {
  const market = String(value || '').trim().toUpperCase();

  if (market === 'USA') {
    return 'US';
  }

  if (market === 'SA') {
    return 'ZA';
  }

  if (market === 'US' || market === 'ZA' || market === 'BM') {
    return market;
  }

  return '';
}

/**
 * @param {HTMLFormElement} form
 * @returns {boolean}
 */
function hasRecaptcha(form) {
  return Boolean(form.querySelector(RECAPTCHA_SELECTOR));
}

/**
 * @param {HTMLFormElement} form
 * @returns {string}
 */
function getCaptchaToken(form) {
  if (!hasRecaptcha(form)) {
    return '';
  }

  const responseField = form.querySelector(RECAPTCHA_RESPONSE_SELECTOR);

  if (responseField instanceof HTMLTextAreaElement || responseField instanceof HTMLInputElement) {
    return responseField.value.trim();
  }

  // Never borrow the default widget's token: registration may use a different widget.
  return '';
}

/**
 * Reuse the same id across retries so a timed-out request cannot create duplicate leads.
 *
 * @param {HTMLElement} formRoot
 * @returns {string}
 */
function getSubmissionId(formRoot) {
  if (!formRoot.dataset.submissionId) {
    const id = typeof window.crypto?.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    formRoot.dataset.submissionId = `shopify-lead-${id}`;
  }

  return formRoot.dataset.submissionId;
}

/**
 * @param {HTMLFormElement} form
 */
function resetRecaptcha(form) {
  if (!hasRecaptcha(form)) return;

  const recaptcha = getRecaptchaApi();
  const responseField = form.querySelector(RECAPTCHA_RESPONSE_SELECTOR);
  const widget = responseField?.id?.match(/^g-recaptcha-response(?:-(\d+))?$/);

  if (widget && recaptcha && typeof recaptcha.reset === 'function') {
    recaptcha.reset(Number(widget[1] || 0));
  }
}

/**
 * @returns {{ getResponse?: Function, reset?: Function } | null}
 */
function getRecaptchaApi() {
  return window.grecaptcha?.enterprise || window.grecaptcha || null;
}

/**
 * @param {Response} response
 * @returns {Promise<Record<string, unknown> | null>}
 */
async function parseJsonResponse(response) {
  const contentType = response.headers.get('content-type') || '';

  if (!contentType.includes('application/json')) {
    return null;
  }

  try {
    const data = await response.json();
    return data && typeof data === 'object' && !Array.isArray(data) ? data : null;
  } catch {
    return null;
  }
}

/**
 * @param {Record<string, unknown> | null} responseData
 * @returns {string}
 */
function getSuccessMessage(responseData) {
  const leadId = responseData?.id;

  if (typeof leadId === 'number' || typeof leadId === 'string') {
    return `${SUCCESS_MESSAGE} Reference #${leadId}.`;
  }

  return SUCCESS_MESSAGE;
}

/**
 * @param {Response} response
 * @param {Record<string, unknown> | null} responseData
 * @returns {string}
 */
function getErrorMessage(response, responseData) {
  const detail = responseData?.detail || responseData?.message || responseData?.error;

  if (typeof detail === 'string' && detail.trim()) {
    return `We could not send your request: ${detail.trim()}`;
  }

  return `${DEFAULT_ERROR_MESSAGE} (${response.status})`;
}

/**
 * @param {unknown} error
 * @returns {string}
 */
function getNetworkErrorMessage(error) {
  if (error instanceof TypeError && error.message.toLowerCase().includes('networkerror')) {
    return `The CRM rejected this website origin (${window.location.origin}). Please add this exact URL to the CRM CORS allowed origins.`;
  }

  if (error instanceof TypeError && error.message.toLowerCase().includes('fetch')) {
    return `The CRM request was blocked by the browser for ${window.location.origin}. Please check the CRM CORS allowed origins.`;
  }

  return error instanceof Error ? error.message : DEFAULT_ERROR_MESSAGE;
}

function initializeCountrySelects() {
  const countryOptions = getCountryOptions();

  document.querySelectorAll(`${LEAD_FORM_SELECTOR} select[data-country-select]`).forEach((select) => {
    if (!(select instanceof HTMLSelectElement) || select.dataset.countryPopulated === 'true') return;

    const selectedValue = select.value;
    const placeholder = select.querySelector('option[value=""]')?.textContent || 'Country *';

    select.replaceChildren(new Option(placeholder, ''));

    countryOptions.forEach(({ name }) => {
      select.add(new Option(name, name, false, name === selectedValue));
    });

    select.add(new Option('Other', 'Other', false, selectedValue === 'Other'));
    select.dataset.countryPopulated = 'true';
  });
}

/**
 * @returns {{ code: string, name: string }[]}
 */
function getCountryOptions() {
  const DisplayNames = window.Intl && Intl.DisplayNames;

  if (!DisplayNames) {
    return [];
  }

  const regionNames = new DisplayNames(['en'], { type: 'region' });

  return COUNTRY_CODES.map((code) => ({ code, name: regionNames.of(code) || code }))
    .filter(({ name }) => Boolean(name))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * @param {HTMLFormElement} form
 * @param {string} captchaToken
 * @returns {Record<string, string | string[] | boolean>}
 */
function buildPayload(form, captchaToken = '', submissionId = '') {
  const message = buildMessage(form);
  const smsConsent = getCheckboxValue(form, 'contact[allow_sms_messaging]');
  const payload = {
    firstName: getFieldValue(form, 'contact[first_name]'),
    lastName: getFieldValue(form, 'contact[last_name]'),
    email: getFieldValue(form, 'contact[email]'),
    phone: getPhoneValue(form),
    country: getFieldValue(form, 'contact[country]'),
    how_did_you_hear: getFieldValue(form, 'contact[how_did_you_hear_about_us]') || DEFAULT_HOW_DID_YOU_HEAR,
    interests: getInterests(form),
    submissionId,
    source: 'website-lead-form',
    sourceWebsite: getSourceWebsite(),
  };

  if (smsConsent !== null) {
    payload.allow_sms_messaging = smsConsent;
  }

  addOptionalField(payload, 'stateProvince', getFieldValue(form, 'contact[state_province]'));
  addOptionalField(payload, 'referralNameCode', getFieldValue(form, 'contact[referral_name_code]'));
  addOptionalField(payload, 'message', message);
  addOptionalField(payload, 'captchaToken', captchaToken);

  return payload;
}

/**
 * @param {HTMLFormElement} form
 * @param {string} name
 * @returns {string}
 */
function getFieldValue(form, name) {
  const field = form.elements.namedItem(name);

  if (field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement) {
    return field.value.trim();
  }

  return '';
}

/**
 * Combines an optional calling-code selector with the submitted phone number.
 * Forms without a calling-code selector keep their existing behavior.
 *
 * @param {HTMLFormElement} form
 * @returns {string}
 */
function getPhoneValue(form) {
  const callingCode = getFieldValue(form, 'contact[phone_country_code]');
  const phoneNumber = getFieldValue(form, 'contact[phone]');

  return [callingCode, phoneNumber].filter(Boolean).join(' ');
}

/**
 * @param {HTMLFormElement} form
 * @param {string} name
 * @returns {boolean | null}
 */
function getCheckboxValue(form, name) {
  const field = form.elements.namedItem(name);

  if (field instanceof HTMLInputElement && field.type === 'checkbox') {
    return field.checked;
  }

  return null;
}

/**
 * @param {HTMLFormElement} form
 * @returns {string}
 */
function buildMessage(form) {
  const baseMessage = getFieldValue(form, 'contact[body]');
  const details = [];

  addMessageDetail(details, 'Role/Practice', getFieldValue(form, 'contact[role_practice]'));
  addMessageDetail(details, 'Business / Practice Name', getFieldValue(form, 'contact[business_practice_name]'));
  addMessageDetail(details, 'Professional Type', getFieldValue(form, 'contact[professional_type]'));
  addMessageDetail(details, 'Product', getFieldValue(form, 'contact[product_context]'));
  addMessageDetail(details, 'Product URL', getFieldValue(form, 'contact[product_url]'));

  if (!details.length) {
    return baseMessage;
  }

  return [baseMessage, details.join('\n')].filter(Boolean).join('\n\n');
}

/**
 * @param {string[]} details
 * @param {string} label
 * @param {string} value
 */
function addMessageDetail(details, label, value) {
  if (value) {
    details.push(`${label}: ${value}`);
  }
}

/**
 * @returns {string}
 */
function getSourceWebsite() {
  const hostname = window.location.hostname.toLowerCase().replace(/^www\./, '');

  if (ALLOWED_SOURCE_WEBSITES.has(hostname)) {
    return hostname;
  }

  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.myshopify.com')) {
    return DEFAULT_SOURCE_WEBSITE;
  }

  if (hostname.endsWith('.drbrownslab.com')) {
    return DEFAULT_SOURCE_WEBSITE;
  }

  if (hostname.endsWith('.drbrownsgroup.com')) {
    return 'drbrownsgroup.com';
  }

  if (hostname.endsWith('.tricoexam.com')) {
    return 'tricoexam.com';
  }

  return DEFAULT_SOURCE_WEBSITE;
}

/**
 * @param {HTMLFormElement} form
 * @returns {string[]}
 */
function getInterests(form) {
  return Array.from(form.querySelectorAll('input[data-interest]:checked'))
    .map((input) => input instanceof HTMLInputElement ? input.dataset.interest?.trim() : '')
    .filter(Boolean);
}

/**
 * @param {Record<string, string | string[] | boolean>} payload
 * @param {string} key
 * @param {string} value
 */
function addOptionalField(payload, key, value) {
  if (value) {
    payload[key] = value;
  }
}

/**
 * Redirects to a same-origin URL after a successful lead submission.
 * Existing lead forms are unchanged unless they opt in with a data attribute.
 *
 * @param {HTMLElement} formRoot
 */
function scheduleSuccessRedirect(formRoot) {
  const redirectPath = formRoot.dataset.leadSuccessRedirect?.trim();

  if (!redirectPath) return;

  const redirectUrl = new URL(redirectPath, window.location.origin);

  if (redirectUrl.origin !== window.location.origin) return;

  window.setTimeout(() => {
    window.location.assign(redirectUrl.href);
  }, 900);
}

/**
 * @param {Element | null} submitButton
 * @param {boolean} isSubmitting
 */
function setSubmitting(submitButton, isSubmitting) {
  if (submitButton instanceof HTMLButtonElement || submitButton instanceof HTMLInputElement) {
    submitButton.disabled = isSubmitting;
    submitButton.setAttribute('aria-busy', String(isSubmitting));
  }
}

/**
 * @param {HTMLFormElement} form
 * @param {'success' | 'error'} [type]
 * @param {string} [message]
 */
function setStatus(form, type, message) {
  const status = form.querySelector(STATUS_SELECTOR);

  if (!(status instanceof HTMLElement)) return;

  status.classList.add('hidden');
  status.classList.remove('contact-form__success', 'contact-form__error');
  status.removeAttribute('role');
  status.textContent = '';

  if (!type || !message) return;

  status.classList.add(type === 'success' ? 'contact-form__success' : 'contact-form__error');
  status.setAttribute('role', type === 'success' ? 'status' : 'alert');
  status.textContent = message;
  status.classList.remove('hidden');
  status.focus();
}
